// TicketCommsPanel (2026-11-04, Lyndon): who asked, site contact, alternates, site history permission, reopen, linked history.
import { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, Divider, Grid, Stack, TextField, Typography } from '@mui/material';
import api from '@/services/api';

const FIELDS = [
  ['requester_name', 'Requested by'], ['requester_phone', 'Requester phone'], ['requester_email', 'Requester email'],
  ['requester_alt_name', 'Requester alternate'], ['requester_alt_phone', 'Alternate phone'], ['requester_alt_email', 'Alternate email'],
  ['contact_alt_name', 'Site contact alternate'], ['contact_alt_phone', 'Alternate phone'], ['contact_alt_email', 'Alternate email'],
];
const CLOSED = ['completed', 'cancelled', 'denied'];

export default function TicketCommsPanel({ ticketId, status }: { ticketId: number; status?: string }) {
  const [f, setF] = useState<Record<string, string>>({});
  const [creator, setCreator] = useState('');
  const [hist, setHist] = useState<any>(null);
  const [msg, setMsg] = useState('');
  const load = useCallback(() => {
    api.get(`/tech-app/tickets/${ticketId}/people`).then((r: any) => {
      const q = r.data?.requester || {}, c = r.data?.contact || {};
      setCreator(r.data?.created_by || '');
      setF({ requester_name: q.name || '', requester_phone: q.phone || '', requester_email: q.email || '', requester_alt_name: q.alt_name || '',
        requester_alt_phone: q.alt_phone || '', requester_alt_email: q.alt_email || '', contact_alt_name: c.alt_name || '', contact_alt_phone: c.alt_phone || '', contact_alt_email: c.alt_email || '' });
    }).catch(() => {});
    api.get(`/tech-app/tickets/${ticketId}/history`).then((r: any) => setHist(r.data)).catch(() => {});
  }, [ticketId]);
  useEffect(() => { load(); }, [load]);
  const run = async (p: Promise<any>, ok: string) => {
    try { const r = await p; setMsg(r.data?.ticket_number ? `Reopened as ${r.data.ticket_number}` : ok); load(); }
    catch (e: any) { setMsg(e?.response?.data?.detail || 'That did not save.'); }
  };
  const links = (hist?.tickets || []).filter((t: any) => t.id !== ticketId);
  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ mb: 2 }} />
      {msg ? <Alert severity="info" sx={{ mb: 1 }} onClose={() => setMsg('')}>{msg}</Alert> : null}
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>People on this ticket</Typography>
      {creator ? <Typography variant="body2" sx={{ mb: 1 }}>Ticket created by {creator}</Typography> : null}
      <Grid container spacing={1.5}>
        {FIELDS.map(([k, l]) => (
          <Grid item xs={12} sm={4} key={k}>
            <TextField size="small" fullWidth label={l} value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
          </Grid>
        ))}
      </Grid>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1.5 }}>
        <Button size="small" variant="outlined" onClick={() => run(api.put(`/tech-app/tickets/${ticketId}/people`, f), 'Saved.')}>Save people</Button>
        <Button size="small" variant="outlined" onClick={() => run(api.post(`/tech-app/tickets/${ticketId}/history-grant`), 'The assigned tech can now see this site\'s history.')}>Allow tech to see site history</Button>
        {status && CLOSED.includes(status) ? <Button size="small" variant="contained" onClick={() => run(api.post(`/tech-app/tickets/${ticketId}/reopen`, {}), 'Reopened.')}>Reopen as new ticket</Button> : null}
      </Stack>
      {links.length ? <Typography variant="body2" sx={{ mt: 1.5 }}>Linked tickets: {links.map((t: any) => t.ticket_number).join(', ')}</Typography> : null}
    </Box>
  );
}
